/**
 * External dependencies.
 */
import React from "react";
import { useRouter } from "next/router";

/**
 * Internal dependencies.
 */
import Intro from "components/intro/intro";
import ListTags from "components/list-tags/list-tags";
import { TagsProps } from "types/tag";

interface BlogIntroProps {
  title: String;
  tags: TagsProps[];
}

const BlogIntro: React.FC<BlogIntroProps> = ({ title, tags }) => {
  const router = useRouter();
  const currentTag = router.query.slug ?? "";

  return (
    <Intro Smaller={false} noMargin={false} className="intro--blog no-images">
      {title && <h1 className="h2">{title}</h1>}

      {tags.length > 0 && <ListTags tags={tags} currentTag={currentTag} />}
    </Intro>
  );
};

export default BlogIntro;
